import { FormDialogSecteurComponent } from './form-dialog-secteur/form-dialog-secteur.component';
import { FormDialogErrorsComponent } from './form-dialog-errors/form-dialog-errors.component';
import { FormDialogFormulaireComponent } from './form-dialog-formulaire/form-dialog-formulaire.component';
import { FormDialogFormulaireWithSFComponent } from './form-dialog-formulaire-with-sf/form-dialog-formulaire-with-sf.component';
import { ConfirmComponent } from './confirm/confirm.component';
import { FormDialogSliderComponent } from './sliders/form-dialog-slider/form-dialog-slider.component';
import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '../../../material.module';
import { RouterModule } from '@angular/router';
import { MotorAtylModule } from '../../motor-form-atyl';
import { DesignModule } from '../../../views/partials/design/design.module';
import { PartialsModule } from '../../../views/partials/partials.module';
import { BaseAtylModule } from '../../../base/base.module';
//import { DossierPageFormulaireComponent } from '../../../views/pages/recherche/dossier-page-tabs/dossier-page-formulaire/dossier-page-formulaire.component'
import { PipesModule } from '../../../pipes/pipes.module'

const COMPONENTS = [
    FormDialogSecteurComponent,
    FormDialogErrorsComponent,
    FormDialogFormulaireComponent,
    FormDialogFormulaireWithSFComponent,
    ConfirmComponent,
    FormDialogSliderComponent
    
];

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        BaseAtylModule,
        PartialsModule,
        MaterialModule,
        DesignModule,
        RouterModule,
        MotorAtylModule,
		PipesModule,
     //   DossierPageFormulaireComponent
    ],
    declarations: [
        ...COMPONENTS
    ],
    exports: [
        ...COMPONENTS
    ],
    entryComponents: [
        ...COMPONENTS
    ],
    providers: [
        DatePipe
    ]
})
export class FormDialogAtylModule { }